export { default } from './PatientRecords';
